import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Utils } from '../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { CustomDialogService } from '../../../services/customdialog.service';
import { interval, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DialerFirmwareStatusDialogComponent } from './firmware-status-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'digitalservicesdefaultfirmware',
  templateUrl: './defaultfirmware.component.html',
    styleUrls: ['./defaultfirmware.component.less'],
    standalone: false
})
export class DigitalServicesDefaultFirmwareComponent implements OnInit {

    subscriptionStage: any;
    deviceTypesAndModels!: DialerTypesAndModelsResponse;
    deviceTypes: string[] = [];
    modelNumbers: string[] = [];
    selectedDeviceType!: string;
    selectedVendor!: string;
    selectedModelNumbers: string[] = [];
    selectedRegulatoryCode!: string;
    defaultFW: string = '';
    availableRegulatoryCodes!: string[];
    selectedFirmwareVersion!: string;
    availableFirmwareVersions: string[] = [];
    availableVendors: string[] = [];
    availableFirmwareResponse!: AvailableFirmwareResponse;
    firmwareVersionPerModelVersion: { [modelVersion: string]: { [regCode: string]: {defaultFW: string, availableFW: string[]}} } = {};
    vendorsPerDeviceType: { [deviceType: string]: string[] } = {};
    pollingSubscription: Subscription | undefined;
    firmwareFile: File | null | undefined;
    assignDefaultFWCorrelationId!: string;
    firmwareAssignmentStatus: FirmwareAssignmentStatusResponse | undefined;
    isSettingDefaultFirmware = false;
    statusDialogRef: MatDialogRef<DialerFirmwareStatusDialogComponent> | undefined;
    statusDialogData = { status: undefined as FirmwareAssignmentStatusResponse | undefined };
    totalAvailableRegCodes: TotalAvailableRegulatoryCodes | undefined;

    @ViewChild('firmwareFileinput') firmwareFileInput!: ElementRef<HTMLInputElement>;

    constructor(private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
        , private defaults: DefaultValuesService
        , private customDialog: CustomDialogService
        , private toastrService: ToastrService
        , private dialog: MatDialog,   ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => {
            this.getAvailableRegulatoryCodes();
            this.getDeviceTypesAndModels();
            this.selectedDeviceType = '';
            this.clearFileInput();         
        });
        this.getAvailableRegulatoryCodes();
        this.getDeviceTypesAndModels();       
    }

    ngOnDestroy() {
        if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
        }
        if (this.subscriptionStage)
            this.subscriptionStage.unsubscribe();
    }   

    

    deviceTypeChange(): void {
        this.setAvailableVendors();
        this.setAvailableRegulatoryCodes();
        this.setAvailableModelNumbers();
        this.loadAvailableFirmware();      
    }

    regulatoryCodeChange(): void {
        this.loadAvailableFirmware();  
    }

    getModelText(): string {

        const selected = this.selectedModelNumbers || [];

        if (selected.length === 1) {
            return selected[0];
        } else {
            return `${this.selectedModelNumbers.length} selected`;
        }
    }

    getToolTipModelsSelected(): string {
        const selected = this.selectedModelNumbers || [];
        return selected.length > 0 ? selected.join(', ') : 'No models selected';
    }

    isSetDefaultDisabled(): boolean {
        return this.selectedDeviceType === '' ||
            this.selectedModelNumbers.length === 0 ||
            this.selectedRegulatoryCode === '' ||
            this.selectedFirmwareVersion === '' ||
            this.selectedVendor === '';
    }

    getSetDefaultFirmwareTip(): string {
        if (this.isSettingDefaultFirmware) {
            return 'Setting default firmware, please wait...';
        }
        if (!this.selectedDeviceType || !this.selectedRegulatoryCode || !this.selectedFirmwareVersion || this.selectedVendor === '' || this.selectedModelNumbers.length === 0) {
            return 'Please select device type, vendor, regulatory code, model/s and firmware version.';
        }
        return 'Set the selected firmware as default.';
    }
  
    onModelSelectorClosed(): void {
        this.setFirmwareVersionVariables();
    }

    onVendorChange(): void{
        this.setAvailableModelNumbers();
    }

    openStatusDialog(): void {
        this.statusDialogRef = this.dialog.open(DialerFirmwareStatusDialogComponent, {
            data: this.statusDialogData,
            disableClose: true,
            panelClass: 'firmware-status-dialog-panel'
        });
        this.statusDialogRef.afterClosed().subscribe(() => {
            this.statusDialogRef = undefined;
        });
    }

    setDefaultVersion(): void {
        this.isSettingDefaultFirmware = true;
        this.firmwareAssignmentStatus = undefined;
        this.statusDialogData.status = undefined; // Reset status dialog data

        this.openStatusDialog();

        const body: SetDefaultFirmwareVersionBody = {
            dialerType: this.selectedDeviceType,
            regulatoryCode: this.selectedRegulatoryCode,
            firmwareVersion: this.selectedFirmwareVersion,
            modelNumber: this.selectedModelNumbers.join(','),
            vendorName: this.selectedVendor
        };
        const firmwareVersionSent = this.selectedFirmwareVersion;
        Utils.httpPutDialerDefaultFirmware(
            this.http,
            this.baseUrl,
            body,
            this,
            function (tthis: DigitalServicesDefaultFirmwareComponent, response: AssignDefaultFirmwareResponse) {
                tthis.assignDefaultFWCorrelationId = response.correlationID;
                tthis.getDialerFirmwareAssignmentStatus();
                tthis.startPollingDefaultFirmwareStatus();
                tthis.defaultFW = firmwareVersionSent;
            },
            function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                tthis.isSettingDefaultFirmware = false;
                tthis.toastrService.error('There was an error setting default firmware. Please contact the administrator.', 'Error');
            });
    }

    onFileChange(event: any) {
        event = (event?.target as HTMLInputElement)?.files;
        if (event && event.length) {
            this.firmwareFile = event[0];
        }
    }

    uploadFirmwareFile() {
        const titleDialog = 'Upload firmware Image';
        var success = false;
        if (this.selectedDeviceType === '' || this.selectedModelNumbers.length == 0 || this.selectedVendor === '') {
            this.customDialog.openDisplayInfoDialog({
                title: titleDialog,
                message: 'Please, select a device type, a vendor and at least one model',
                caller: this
            });
        }
        else if (this.firmwareFile == null || this.firmwareFile == undefined || !this.firmwareFile.name.toLowerCase().endsWith('.bin')) {
            this.customDialog.openDisplayInfoDialog({
                title: titleDialog,
                message: 'Please, select a valid firmware file (.bin)',
                caller: this
            })
        }
        else {
            this.customDialog.openConfirm({
                title: titleDialog,
                message: 'You are going to upload the firmware file: ' + this.firmwareFile.name + ' for the device type: ' + this.selectedDeviceType + ' and the model/s: ' + this.selectedModelNumbers.join(', ') + ' Do you want to continue?',
                caller: this
            });


            this.customDialog.confirmed().subscribe(res => {
                if (res.confirmed) {

                    const formData = new FormData();
                    formData.append('DeviceType', this.selectedDeviceType);
                    formData.append('Vendor', this.selectedVendor)
                    formData.append('ModelNumbers', this.selectedModelNumbers.join(','));
                    if (this.firmwareFile) {
                        formData.append('FirmwareFile', this.firmwareFile, this.firmwareFile.name);
                    }

                    Utils.httpPostUploadNewFirmwareDeviceTypeAndModels(this.http
                        , this.baseUrl
                        , formData
                        , this
                        , function (tthis: DigitalServicesDefaultFirmwareComponent, response: any) {
                            if (response && response.isSuccessStatusCode) {
                                tthis.customDialog.openDisplayInfoDialog({
                                    title: titleDialog,
                                    message: 'Firmware file image succesfully uploaded.',
                                    caller: tthis
                                });
                                tthis.getDeviceTypesAndModels();
                                tthis.selectedDeviceType = '';
                                tthis.selectedVendor = '';
                                tthis.selectedModelNumbers = [];
                                tthis.clearFileInput();
                                tthis.firmwareFile = null;
                            }
                            else {
                                let errorMsg = 'Error uploading the firmware file.';
                                if (response && response.status) {
                                    errorMsg += `\nStatus: ${response.status}`;
                                }
                                if (response && response.statusText) {
                                    errorMsg += `\n${response.statusText}`;
                                }
                                tthis.customDialog.openDisplayInfoDialog({
                                    title: titleDialog,
                                    message: errorMsg,
                                    caller: tthis
                                });
                            }
                        }
                        , function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                            tthis.customDialog.openDisplayInfoDialog({
                                title: titleDialog,
                                message: 'Error uploading the firmware file.\n' + JSON.stringify(error.error),
                                caller: tthis
                            });
                        }
                    )
                }
            })
        }
    }

    clearFileInput() {
        if (this.firmwareFileInput && this.firmwareFileInput.nativeElement) {
            this.firmwareFileInput.nativeElement.value = '';
        }
    }

    private getDeviceTypesAndModels(): void {
        Utils.httpGetAllDeviceTypesAndModels(this.http
            , this.baseUrl
            , this
            , function (tthis: DigitalServicesDefaultFirmwareComponent, response: DialerTypesAndModelsResponse) {
                tthis.deviceTypesAndModels = response;
                tthis.updateUniqueDeviceTypes();
            },
            function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                tthis.toastrService.error('There was an error loading dialer types and models. Please contact the administrator.', 'Error');
            }
        )
    }

    private getAvailableRegulatoryCodes(): void {
        Utils.httpGetTotalAvailableRegulatorycodes(
            this.http,
            this.baseUrl,
            this,
            function (tthis: DigitalServicesDefaultFirmwareComponent, response: TotalAvailableRegulatoryCodes) {
                tthis.totalAvailableRegCodes = response;
            },
            function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                tthis.toastrService.error('There was an error loading available regulatory codes. Please contact the administrator.', 'Error');
            }
        )
    }

    private updateUniqueDeviceTypes(): void {
        const deviceTypesSet = new Set<string>();

        for (const vendor in this.deviceTypesAndModels) {
            const dialers = this.deviceTypesAndModels[vendor];
            for (const dialer of dialers) {
                const type = dialer.DialerType;
                deviceTypesSet.add(type);
                if (!this.vendorsPerDeviceType[type]) {
                    this.vendorsPerDeviceType[type] = [];
                }
                if (!this.vendorsPerDeviceType[type].includes(vendor)) {
                    this.vendorsPerDeviceType[type].push(vendor);
                }
            }
        }
        this.deviceTypes = Array.from(deviceTypesSet);
        this.deviceTypeChange();
    }

    private loadAvailableFirmware() {
        this.defaultFW = '';
        this.availableFirmwareVersions = [];
        this.selectedFirmwareVersion = '';
        if (this.selectedDeviceType && this.selectedDeviceType != '' && this.selectedRegulatoryCode && this.selectedRegulatoryCode != '') {
            Utils.httpGetDialersAvailableFirmware(
                this.http,
                this.baseUrl,
                this.selectedDeviceType,
                this.selectedRegulatoryCode,
                this,
                function (tthis: DigitalServicesDefaultFirmwareComponent, response: AvailableFirmwareResponse) {
                    tthis.availableFirmwareResponse = response;
                    tthis.mapAvailableFirmware();
                },
                function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                    tthis.toastrService.error('There was an error loading available firmware. Please contact the administrator.', 'Error');
                }
            );
        }
    }

    private getDialerFirmwareAssignmentStatus(): void {
        Utils.httpGetDialerFirmwareAssignmentStatus(
            this.http,
            this.baseUrl,
            this.assignDefaultFWCorrelationId,
            this,
            function (tthis: DigitalServicesDefaultFirmwareComponent, response: FirmwareAssignmentStatusResponse) {
                tthis.firmwareAssignmentStatus = response;
                tthis.statusDialogData.status = response;
                setTimeout(() => tthis.checkIfPollingShouldStop(), 100);
            },
            function (tthis: DigitalServicesDefaultFirmwareComponent, error: any) {
                tthis.firmwareAssignmentStatus = undefined;
            }
        );
    }

    private startPollingDefaultFirmwareStatus(): void {
        this.pollingSubscription = interval(10000).subscribe(() => {
            this.getDialerFirmwareAssignmentStatus();
        });
    }

    private checkIfPollingShouldStop(): void {
        const status = this.firmwareAssignmentStatus;
        if (!status || !status.processSteps?.length) {
            return;
        }

        const lastStep = status.processSteps[status.processSteps.length - 1];
        const lastStatusObj = lastStep.processStepStatuses[lastStep.processStepStatuses.length - 1];
        const lastStatus = lastStatusObj?.status?.toLowerCase();

        if (lastStatus === 'finished' || lastStatus === 'failed') {
            if (this.pollingSubscription) {
                this.pollingSubscription.unsubscribe();
                this.pollingSubscription = undefined;                
            }

            this.isSettingDefaultFirmware = false;

            if (lastStatus === 'finished') {
                this.firmwareAssignmentStatus = undefined;
                // Close the dialog if open
                if (this.statusDialogRef) {
                    this.statusDialogRef.close();
                    this.statusDialogRef = undefined;
                }
                this.toastrService.success('Firmware default version assignment process finished successfully.', 'Success');
            } else if (lastStatus === 'failed') {
                this.toastrService.error('Firmware default version assignment process failed.', 'Error');
            }
        }
    }

    private setAvailableVendors(): void {
        this.selectedVendor = '';
        this.availableVendors = this.vendorsPerDeviceType[this.selectedDeviceType] || [];
        if (this.availableVendors.length === 1) {
            this.selectedVendor = this.availableVendors[0];
        }
    }

    private setAvailableModelNumbers(): void {
        this.modelNumbers = [];
        this.selectedModelNumbers = [];

        if (this.selectedVendor !== '') {
            this.deviceTypesAndModels[this.selectedVendor].forEach((item: any) => {
                if (item.DialerType === this.selectedDeviceType) {
                    this.modelNumbers.push(...item.ModelNumbers);
                }
            });
        }
    }

    private setAvailableRegulatoryCodes(): void {
        if (!this.totalAvailableRegCodes) {
            return;
        }
        this.selectedRegulatoryCode = '';
        this.availableRegulatoryCodes = this.totalAvailableRegCodes.regulatoryCodes[this.selectedDeviceType] || [];
        if (this.availableRegulatoryCodes.length === 1) {
            this.selectedRegulatoryCode = this.availableRegulatoryCodes[0];
        }
    }

    private setFirmwareVersionVariables(): void {
        const regCode = this.selectedRegulatoryCode;

        if (this.selectedModelNumbers.length === 0) {
            return;
        }

        const model = this.selectedModelNumbers[0];
        const firmwareInfo = this.firmwareVersionPerModelVersion[model]?.[regCode];

        if (!firmwareInfo) {
            return;
        }

        this.availableFirmwareVersions = firmwareInfo.availableFW;
        this.defaultFW = firmwareInfo.defaultFW;
        this.selectedFirmwareVersion = this.defaultFW;
    }

    private mapAvailableFirmware(): void {
        this.firmwareVersionPerModelVersion = {} as {
            [modelVersion: string]: { [regCode: string]: { defaultFW: string, availableFW: string[] } }
        };

        const images = this.availableFirmwareResponse?.availableFirmwareImages;
        if (!images) {
            return;
        }
        images.forEach(img => {
            const model = img.modelVersion;
            const fw = img.firmwareVersion;
            const regCode = img.regulatoryCode;

            this.ensureFirmwareEntry(model, regCode);

            const entry = this.firmwareVersionPerModelVersion[model][regCode];
            if (img.isDefault) {
                entry.defaultFW = fw;
            }
            if (!entry.availableFW.includes(fw)) {
                entry.availableFW.push(fw);
            }
        });
        this.setFirmwareVersionVariables();
    }

    private ensureFirmwareEntry(model: string, regCode: string): void {
        if (!this.firmwareVersionPerModelVersion[model]) {
            this.firmwareVersionPerModelVersion[model] = {} as { [regCode: string]: { defaultFW: string, availableFW: string[] } };
        }
        if (!this.firmwareVersionPerModelVersion[model][regCode]) {
            this.firmwareVersionPerModelVersion[model][regCode] = { defaultFW: '', availableFW: [] };
        }
    }   
}
